
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="w-full px-6 py-3">
        <div className="w-full">
          <div className="flex items-center justify-between">
            <div 
              className={`flex items-center cursor-pointer transition-all duration-300 ${isScrolled ? 'opacity-100 visible' : 'opacity-0 invisible'}`} 
              onClick={() => scrollToSection('inicial')}
            >
              <img 
                src="https://static.readdy.ai/image/d1ac1a7e8ecb2076670ea669c1984b4f/c4f4ac0c34bfc1aec6e193fac5e60841.png" 
                alt="Persona Pro Logo" 
                className="h-12 w-auto"
              />
            </div>
            
            <div className="hidden md:flex items-center space-x-8">
              <button 
                onClick={() => scrollToSection('inicial')}
                className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-[#D4AF37] ${isScrolled ? 'text-gray-700' : 'text-white'}`}
              >
                Inicial
              </button>
              <button 
                onClick={() => scrollToSection('quem-somos')}
                className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-[#D4AF37] ${isScrolled ? 'text-gray-700' : 'text-white'}`}
              >
                Quem Somos
              </button>
              <button 
                onClick={() => scrollToSection('servicos')}
                className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-[#D4AF37] ${isScrolled ? 'text-gray-700' : 'text-white'}`}
              >
                Serviços
              </button>
              <button 
                onClick={() => scrollToSection('comentarios')}
                className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-[#D4AF37] ${isScrolled ? 'text-gray-700' : 'text-white'}`}
              >
                Comentários
              </button>
              <button 
                onClick={() => scrollToSection('contato')}
                className="bg-[#D4AF37] text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-[#B8941F] transition-colors whitespace-nowrap"
              >
                Contato
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
